export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

export const showNotification = ({
  message,
  color = "info",
  title = null,
  duration = 4500,
  actionLabel = null,
  actionTo = null,
}) => ({
  type: SHOW_NOTIFICATION,
  payload: { message, color, title, duration, actionLabel, actionTo },
});

export const hideNotification = () => ({
  type: HIDE_NOTIFICATION,
});
